/* eslint-disable react/prop-types */
import React from 'react'
import FieldVisual from './FieldVisual'

import VenueMap from '../../VenueMap'

const pos = {
    lf: 'translate(-100,-300) scale(3)',
    cf: 'translate(-500,-160) scale(3)',
    rf: 'translate(-850,-300) scale(3)',
    first: 'translate(-900,-1100) scale(4)',
    second: 'translate(-835,-875) scale(4)',
    ss: 'translate(-700,-875) scale(4)',
    third: 'translate(-650,-1050) scale(4)',
    all: '',
}

export default function FieldSVG({ settings, chartOptions, venueId = '7' }) {
    const Venue = VenueMap[venueId]

    if (Venue) {
        const compassVisibility = 'hidden'
        const distancesVisibility = !chartOptions.hideFieldDistances
            ? 'visible'
            : 'hidden'
        const gWrapperClass = 'evp-venue-svg'
        return (
            <g id={gWrapperClass}>
                <Venue width={settings.vizWidth} height={settings.vizHeight} />
                {/* I'm sorry for this hack to add Savant specific styles */}
                <style>
                    {`
                        #grass, #grass_1_, #grass_00000174589876715782793730000007613552633814403240_, #grass_00000090994939672626314830000016650827298536189595_ { fill: #b2dfdb; }
                        #infield_sand { fill: #fff; }
                        #pitching-mound, #pitching-mound_1_ { fill: #fff; }
                        #pitching-rubber, #pitching-rubber_1_ { fill: #c2c2c2; }
                        #warning_track, #Outfield, #outfield, #Outfield_1_, #Outfield_00000139263571581690122010000007572633505411225276_, #Outfield_00000141422436691043141870000004421356628436405419_, #Outfield_00000079455967559065699190000006373183002832104345_,
                        #Outfield_00000094597754240764042730000018294815217055423873_, #outfield_00000176019447424471975020000015478149771427856801_ { fill: #fff; stroke: #e2e2e2; stroke-width: 0.5; }

                        #lines path, #lines_1_ path { stroke: #c2c2c2; stroke-width: 0.75; }
                        #first-base, #second-base, #third-base, #home, #bases_2_ rect, #bases_2_ polygon { fill: #c2c2c2; }
                        #compass, #Compass {visibility: ${compassVisibility};}
                        #${gWrapperClass} text {visibility: ${distancesVisibility}; fill: #b2dfdb; font-family: 'Roboto Condensed'; }
                    `}
                </style>
            </g>
        )
    }

    // The old way, keep for stadiums that we don't have copies of
    let svg = FieldVisual(venueId, !chartOptions.hideFieldDistances)
    svg = svg.replace(
        `<svg`,
        `<svg transform="${pos.all}" id="bam-evp-field-svg" width=${settings.vizWidth} height=${settings.vizHeight}`
    )

    // eslint-disable-next-line react/no-danger
    return <g dangerouslySetInnerHTML={{ __html: svg }} />
}
